module.exports = __webpack_public_path__ + "static/2-1b1267f928b5688c4e5679ddb2226933.jpg";